import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import { Box, Typography } from "@mui/material";

const animations = `
  @keyframes ripple {
    0% { transform: scale(1); opacity: 1; }
    100% { transform: scale(3); opacity: 0; }
  }
  @keyframes travel {
    0% { stroke-dashoffset: 200; }
    100% { stroke-dashoffset: -200; }
  }
  @keyframes rotate-slow {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }
`;

const LogisticsLoader = () => (
  <Box
    sx={{
      height: "100vh",
      width: "100vw",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      bgcolor: "#FFFFFF",
      position: "fixed",
      top: 0,
      left: 0,
      zIndex: 9999,
    }}
  >
    <style>{animations}</style>

    <Box
      sx={{
        position: "relative",
        width: 160,
        height: 160,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {[...Array(3)].map((_, i) => (
        <Box
          key={i}
          sx={{
            position: "absolute",
            width: 40,
            height: 40,
            border: "2px solid #2563EB",
            borderRadius: "50%",
            animation: `ripple 2s infinite ease-out ${i * 0.6}s`,
          }}
        />
      ))}

      <Box
        sx={{
          width: 50,
          height: 50,
          bgcolor: "#1E293B",
          borderRadius: "50%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 2,
          boxShadow: "0 0 20px rgba(37, 99, 235, 0.4)",
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#FFFFFF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
        </svg>
      </Box>

      <svg
        width="160"
        height="160"
        viewBox="0 0 100 100"
        style={{
          position: "absolute",
          animation: "rotate-slow 10s linear infinite",
        }}
      >
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#E2E8F0"
          strokeWidth="1"
          strokeDasharray="5 5"
        />
        <circle
          cx="50"
          cy="50"
          r="45"
          fill="none"
          stroke="#2563EB"
          strokeWidth="2"
          strokeDasharray="30 170"
          strokeLinecap="round"
          style={{ animation: "travel 3s linear infinite" }}
        />
      </svg>
    </Box>

    <Box sx={{ mt: 8, textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: "14px",
          fontWeight: 800,
          color: "#1E293B",
          letterSpacing: "4px",
          textTransform: "uppercase",
          mb: 1,
        }}
      >
        Connecting Nodes
      </Typography>

      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          gap: 0.5,
          alignItems: "center",
        }}
      >
        <Typography
          sx={{ fontSize: "12px", color: "#64748B", fontWeight: 500 }}
        >
          Verifying data packets
        </Typography>
        <Box
          sx={{
            width: 4,
            height: 4,
            bgcolor: "#2563EB",
            borderRadius: "50%",
            animation: "ripple 1s infinite",
          }}
        />
      </Box>
    </Box>

    <Box
      sx={{
        position: "absolute",
        bottom: 40,
        width: "100%",
        px: 4,
        display: "flex",
        justifyContent: "space-between",
        opacity: 0.5,
      }}
    >
      <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>v4.0.2</Typography>
      <Typography sx={{ fontSize: "10px", fontWeight: 700 }}>
        ENCRYPTED CHANNEL
      </Typography>
    </Box>
  </Box>
);

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) return <LogisticsLoader />;

  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;

  return children;
}
